import React from 'react';
import { Button, Col, FormGroup, Input, Label, Row } from 'reactstrap';

export function SectionSettingsPanel({ section, onChange }) {
	if (!section) return null;

	const handleChange = (event) => {
		const { name, value, type, checked } = event.target;
		const nextValue = type === 'checkbox' ? checked : value;
		onChange(name, nextValue);
	};

	return (
		<div className="hb-admin-section-settings">
			<Row>
				<Col md={4}>
					<FormGroup>
						<Label className="hb-admin-label">Name</Label>
						<Input bsSize="sm" name="name" value={section.name || ''} onChange={handleChange} />
					</FormGroup>
				</Col>
				<Col md={3}>
					<FormGroup>
						<Label className="hb-admin-label">Key</Label>
						<Input bsSize="sm" name="key" value={section.key || ''} onChange={handleChange} />
					</FormGroup>
				</Col>
				<Col md={3}>
					<FormGroup>
						<Label className="hb-admin-label">Description</Label>
						<Input bsSize="sm" type="textarea" name="description" value={section.description || ''} onChange={handleChange} rows={1} />
					</FormGroup>
				</Col>
				<Col md={1}>
					<FormGroup>
						<Label className="hb-admin-label">Order</Label>
						<Input bsSize="sm" type="number" name="displayOrder" value={section.displayOrder || 0} onChange={handleChange} />
					</FormGroup>
				</Col>
				<Col md={1}>
					<FormGroup>
						<Label className="hb-admin-label">Active</Label>
						<div>
							<Button
								size="sm"
								color={section.enabled ? 'success' : 'secondary'}
								outline={!section.enabled}
								onClick={() => onChange('enabled', !section.enabled)}
							>
								{section.enabled ? 'On' : 'Off'}
							</Button>
						</div>
					</FormGroup>
				</Col>
			</Row>

			{/* Welsh fields */}
			<Row>
				<Col md={4}>
					<FormGroup>
						<Label className="hb-admin-label">Name (Cymraeg)</Label>
						<Input bsSize="sm" name="name_cy" value={section.name_cy || ''} onChange={handleChange} />
					</FormGroup>
				</Col>
				<Col md={8}>
					<FormGroup>
						<Label className="hb-admin-label">Description (Cymraeg)</Label>
						<Input bsSize="sm" type="textarea" name="description_cy" value={section.description_cy || ''} onChange={handleChange} rows={1} />
					</FormGroup>
				</Col>
			</Row>
		</div>
	);
}
